const suggestingServiceType = Symbol();

export class SuggestingService {
    [suggestingServiceType]: any;
    title: string;
    detail: string;

    constructor(
        title: string,
        detail: string,
    ) {
        this.title = title;
        this.detail = detail;
    }
}
